export type FinancialDataFR = {
  annee: string;
  ca: string;
  ebe: string;
  rn: string;
  effectif: string;
};

export type FinancialData = {
  year: string;
  revenue: string;
  ebe: string;
  resultPostTax: string;
  workers: string;
};

export const translateFinancialData = (fd: FinancialDataFR): FinancialData => {
  return {
    year: fd.annee,
    revenue: fd.ca,
    ebe: fd.ebe,
    resultPostTax: fd.rn,
    workers: fd.effectif,
  };
};

export const translateFinancialDataArray = (fdA: FinancialDataFR[]): FinancialData[] => {
  return fdA.map(e => e && translateFinancialData(e));
};
